export default __webpack_public_path__ + "static/media/undraw_forgot_password_re_hxwm.92f80558.svg";